module.exports = __webpack_public_path__ + "static/img/header.3a6273a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header.png
// module id = nvbl
// module chunks = 3